import { startTransition, useLayoutEffect } from "react"

import { type NavigateFunction, useNavigate, useParams } from "react-router-dom"

import { EPath } from "@/3514/constants"
import { type TScreenBreakpoints, type TUserState, useScreenBreakpoints, useUser } from "@/3514/hooks"
import { EUserRole } from "@/3514/types"
import { SimulabContextProvider, SimulabHeader } from "@/entities/simulab"
import { SimulabCareLink } from "@/features/simulab-chat"
import { ParticipantLayout } from "@/layouts"
import { Simulab } from "@/widgets/simulab"

import "./styles.scss"

export const SimulabChatPage = () => {
    const { user }: TUserState<EUserRole.Participant> = useUser<EUserRole.Participant>()

    const breakpoints: TScreenBreakpoints = useScreenBreakpoints()

    const isMobile: boolean = breakpoints.sm || breakpoints.xs

    const navigate: NavigateFunction = useNavigate()

    const params = useParams()

    useLayoutEffect(
        (): void => (
            !user.isPracticeLabAvailable && startTransition((): void => void navigate(EPath.Participant_Dashboard())),
            void 0
        ),
        [user, navigate]
    )

    return (
        <SimulabContextProvider conversationId={params.conversationId}>
            <ParticipantLayout
                className="simulab-layout !pb-[40px] md:!pb-[100px]"
                noPadding
                closeMenu
                showLogoOnMobile={false}
                title={
                    !isMobile && (
                        <SimulabHeader showCoacheesLink withFeedbackReport withTooltip statusTagVariant="outlined" />
                    )
                }
                header={isMobile && <SimulabHeader withFeedbackReport withTooltip statusTagVariant="outlined" />}
            >
                <Simulab />
                <SimulabCareLink />
            </ParticipantLayout>
        </SimulabContextProvider>
    )
}
